<template>
  <MBaseDialog :isVisible="isVisible">
    <template #content>
      <div class="alert-information">
        <ul class="reser-confirm-box">
          <li class="alert-content" v-html="message"></li>
        </ul>
      </div>
    </template>
    <template #actions>
      <div class="button-wrapper">
        <AButton @click="hideAlert" class="btn-chk">확인</AButton>
      </div>
    </template>
  </MBaseDialog>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { AButton } from '@atoms';
import { useAlertStore } from '@stores';
import { MBaseDialog } from '@molecules';

const alertStore = useAlertStore();

const isVisible = computed(() => alertStore.isAlertVisible);
//const information = computed(() => alertStore.information);
const message = computed(() => alertStore.message);

const hideAlert = () => {
  alertStore.hideAlertDialog();
};
</script>

<style scoped lang="scss">
.alert-content {
  @apply text-center;
  white-space: pre-line;
}

.alert-information {
  padding-top: 18px;
}

.reser-confirm-box {
  max-width: 280px;
  margin: 0 auto 24px;
  padding: 16px 48px 15px;
  border-radius: 16px;
  background-color: #f8f9fc;
  color: #222;
}

.reser-confirm-box span {
  font-weight: bold;
  width: 58px;
  padding-right: 14px;
}

.button-wrapper {
  display: flex;
  gap: 0 7px;
  margin-top: 24px;
}

.btn-chk {
  min-width: 154px;
  border-radius: 60px;
  background-color: var(--color-main);
  color: #fff;
  height: 48px;
  margin: auto;
}
</style>
